import { render, staticRenderFns } from "./repairDamageDesc.vue?vue&type=template&id=3949685a&scoped=true"
import script from "./repairDamageDesc.vue?vue&type=script&lang=js"
export * from "./repairDamageDesc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3949685a",
  null
  
)

export default component.exports